var amdi18n={"__root":{"video":"Video","photo":"Photo","get_photo":"Take/upload photo","camera":"Camera","decode_failed":"QR-Code scan failed"},"__de":{"video":"Video","photo":"Foto","get_photo":"Foto aufnehmen/hochladen","camera":"Kamera","decode_failed":"QR-Code Scan fehlgeschlagen"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/nls/ScanQRCodeView_strings.js
// module id = 351
// module chunks = 1